export const localCalendarDate = (value) => {
  const [year, month, day] = String(value).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const isPublishedRest = (shift) => (
  String(shift?.shift_type || '').toUpperCase() === 'RIPOSO'
);

export const dedupePublishedShiftsByDate = (shifts = []) => {
  const restDates = new Set();
  return shifts.filter((shift) => {
    if (!isPublishedRest(shift)) return true;
    if (restDates.has(shift.shift_date)) return false;
    restDates.add(shift.shift_date);
    return true;
  });
};